import React from "react";
import horseLoader from "../../assets/images/loader_gif.gif";

const Loader = ({ loading = true, text = "" }) => {
  if (!loading) return null;

  return (
    <div className="loader-overlay" style={{textAlign:"center"}}>
      <div className="loader-content">
        <img
          src={horseLoader}
          alt="Loading..."
          className="loader-image" style={{width:"150px"}}
        />
        {text && <p className="loader-text">{text}</p>}
      </div>
    </div>
  );
};

export default Loader;